import {ModelWithParent} from "FormBuilder/Core/Models/ModelWithParenth";
import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";
import {FBFieldWithPriceBaseModel} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Model";
import {OptionsCalculator} from "FormBuilder/Core/Calulators/OptionsCalculator";
import {FBRadioOptions} from "./FBRadio.Options";
import {FBMultipleOptionsBaseModel} from "FormBuilder/Fields/Core/FBMultipleOptionsBase.Model";

export class FBRadioModel  extends FBMultipleOptionsBaseModel<FBRadioOptions,FBColumnModel>{
    SelectedValues:any[];

    constructor(Options: FBRadioOptions, Parent: FBColumnModel) {
        super(Options, Parent);

    }


    get AllowMultiple(): boolean {
        return false;
    }

    public RecreateSelectedOptions(){
          this.SelectedValues=this.Options.Options.filter(x=>x.Selected).map(x=>x.Id);
    }

    protected InitializePriceCalculator() {
        this.calculator=new OptionsCalculator();
        this.calculator.Initialize(this);
    }

    GetValue() {
        if(!this.GetIsVisible())
            return [];
        return this.SelectedValues;
    }

    GetIsUsed(): boolean {
        if(!super.GetIsUsed())
            return false;
        return this.SelectedValues.length>0;
    }

    GetSelectedOptions(){
        if(!this.GetIsVisible())
            return [];
        return this.Options.Options.filter(x=>this.SelectedValues.some(y=>y.toString()==x.Id.toString()));
    }

    GetStoresInformation(): boolean {
        return true;
    }

    protected InternalSerialize(obj: any) {
        super.InternalSerialize(obj);
        obj.SelectedValues=this.GetSelectedOptions().map(x=>x.ToObject());
        for(let currentValue of obj.SelectedValues)
        {
            currentValue.Totals={};
            let total:any=(this.calculator as OptionsCalculator).OptionsTotal.find(x=>x.Id==currentValue.Id);
            if(total==null)
                total={
                    Id:currentValue.Id,
                    Price:0,
                    Quantity:0,
                    RegularPrice:0,
                    SalePrice:0,
                    Total:0
                };
            Object.assign(currentValue,total);
        }
    }

    InitializeStartingValues() {
        let selectedValues=this.Options.Options.filter(x=>x.Selected).map(x=>x.Id);
        if(this.GetPreviousData()!=null)
        {
            let previousSelectedValues:any[]=this.GetPreviousDataProperty('SelectedValues',[]);
            selectedValues=this.Options.Options.filter(x=>previousSelectedValues.some(y=>y.Id==x.Id)).map(x=>x.Id);

        }

        this.SelectedValues=selectedValues;
        this.Quantity=this.GetPreviousDataProperty( 'Quantity',this.ParseNumber(this.Options.QuantityDefaultValue));
    }


    GetDynamicFieldNames(): string[] {
        return ['FBRadio']
    }
}